var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVerifiedIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "verified_user_24dp_5F6368_FILL0_wght400_GRAD0_opsz24 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.12467 12.9584L13.833 8.25008L12.6455 7.06258L9.12467 10.5834L7.37467 8.83341L6.18717 10.0209L9.12467 12.9584ZM9.99967 18.3334C8.06912 17.8473 6.47537 16.7397 5.21842 15.0105C3.96148 13.2813 3.33301 11.3612 3.33301 9.25008V4.16675L9.99967 1.66675L16.6663 4.16675V9.25008C16.6663 11.3612 16.0379 13.2813 14.7809 15.0105C13.524 16.7397 11.9302 17.8473 9.99967 18.3334ZM9.99967 16.5834C11.4441 16.1251 12.6386 15.2084 13.583 13.8334C14.5275 12.4584 14.9997 10.9306 14.9997 9.25008V5.31258L9.99967 3.43758L4.99967 5.31258V9.25008C4.99967 10.9306 5.4719 12.4584 6.41634 13.8334C7.36079 15.2084 8.55523 16.1251 9.99967 16.5834Z",
    fill: "#7636D9"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerifiedIcon);
export default __webpack_public_path__ + "static/media/verified_icon.b5e5a10f2642d59ce8e861ed289d93cd.svg";
export { ForwardRef as ReactComponent };